<template>
  <Row v-if="!loading">
    <Col cols="12">
      <DomainHeading :title="lc.title" :description="lc.description" />
    </Col>
    <Col cols="12">
      <Row class="pa-3" justify="end">
        <AddDomainButton />
      </Row>
    </Col>
    <Col cols="12" v-for="domain in domains" :key="domain.address">
      <DomainCard
        :domain="domain"
        :temporaryDomain="temporaryDomain"
        @updateList="updateList"
      />
    </Col>
  </Row>
</template>

<script>
import { onBeforeMount, computed } from 'vue'
import { Row, Col, useVueRouter, useLocale } from '@locaweb/design-system-vue'
import useDomains from '@/composables/api/useDomains'
import DomainHeading from '@/components/DomainHeading.vue'
import AddDomainButton from './ManageDomain/AddDomainButton.vue'
import DomainCard from './ManageDomain/DomainCard.vue'

export default {
  name: 'ManageDomain',
  components: {
    AddDomainButton,
    DomainHeading,
    DomainCard,
    Row,
    Col
  },
  setup () {
    const { $route } = useVueRouter()
    const lc = useLocale('domains.manageDomain')
    const { data, execute: executeFetch, loading } = useDomains({
      siteId: $route.params.siteId
    })

    onBeforeMount(() => executeFetch())

    const temporaryDomain = computed(() => {
      return data.value.find(domain => domain.isTemporary)
    })

    const domains = computed(() => {
      const hideTemporary = data.value.some(domain => domain.isMain)

      return data.value.filter(domain => !(domain.isTemporary && hideTemporary))
    })

    const updateList = () => {
      executeFetch()
    }

    return { lc, domains, temporaryDomain, loading, updateList }
  }
}
</script>
